var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepsDisplay__wrapper"},[_c('ol',{staticClass:"stepsDisplay__display"},_vm._l((16),function(i){return _c('li',{key:'step-display-' + i,staticClass:"stepsDisplay__item"},[_vm._v(_vm._s(i))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }